import React from 'react'
import '../../CSS/HomeSelectModeS.css'
import { Link } from 'react-router-dom'
import { useStateValue } from '../../StateProvider'; 

const HomeSelectModeS = () => {

    const [{user}] = useStateValue();

    return (
        <>
        
        <div className="home-select-mode">
        
           <div>
           </div>
           
           <div>
           <h2 id='modeSeHead'>Select The Mode Of Session</h2>
                <div className="home-select-modeSubDiv">
                    <div className="selectSessionMode1">
                        <i className="far fa-comments"></i>
                        <Link to={user ? '/AppointmentPage' : '/login_Signup'}>
                            <div className="sessionDivText">
                                <h1>Online Chat Sessions</h1>
                                <small>Chat anonymously with an expert of your choice. This service is available to you anytime, anywhere.</small>
                            </div>
                        </Link>
                    </div>

                    <div className="selectSessionMode2">
                        <i className="fas fa-phone-square-alt"></i>
                        <Link to={user ? '/AppointmentPage' : '/login_Signup'}>
                            <div className="sessionDivText">
                                <h1>Voice Call Sessions</h1>
                                <small>Chat anonymously with an expert of your choice. This service is available to you anytime, anywhere.</small>
                            </div>
                        </Link>
                    </div>

                    <div className="selectSessionMode3">
                        <i className="fa fa-fas fa-video"></i>
                        <Link to={user ? '/AppointmentPage' : '/login_Signup'}>
                            <div className="sessionDivText">
                                <h1>Video Call Sessions</h1>
                                <small>Chat anonymously with an expert of your choice. This service is available to you anytime, anywhere.</small>
                            </div>
                        </Link>
                    </div>
                </div>
           </div> 
        </div>
        </>
    )
}

export default HomeSelectModeS
